import { useTranslation, UseTranslationOptions } from 'react-i18next';
import { TranslationResources } from '@/i18n/types';

type Namespace = keyof TranslationResources;

export function useTypedTranslation<N extends Namespace = 'common'>(
  ns?: N | N[],
  options?: UseTranslationOptions<N>
) {
  return useTranslation(ns, options as any);
}